import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, Redirect } from 'react-router';
import { Button, Col, FormGroup, Label, Row } from 'reactstrap';
import TenantStore from 'src/Stores/Tenant/TenantStore';
import { UserStore } from 'src/Stores/User/UserStore';
import { IOptionFieldList, IOptionFieldListItem } from '../../../../Interfaces/AdminInterface';
import ButtonRow from '../../../ButtonRow';
import { EButton, EInput } from '../../../EInput';


@inject('stores')
@observer
class DynamicFieldListDetails extends React.Component {
    public props: any;
    public listDisposer: any;
    public AdminStore: any;
    public fieldList: IOptionFieldList = new IOptionFieldList();
    public fieldListItem: IOptionFieldListItem = new IOptionFieldListItem();
    public fieldListItems: IOptionFieldListItem[] = [];
    public MessageStore: any;
    public UserStore: UserStore;
    public TenantStore: TenantStore;

    public state = {
        fieldList: this.fieldList,
        fieldListId: 'new',
        isDirty: false,
        redirect: false,
    };

    constructor(props: any) {
        super(props);

        this.AdminStore = this.props.stores.AdminStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.UserStore = this.props.stores.UserStore;
        this.TenantStore = this.props.stores.TenantStore;
        this.addNewOption = this.addNewOption.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSaveList = this.handleSaveList.bind(this);
        this.removeFieldList = this.removeFieldList.bind(this);
    }

    public componentDidMount() {
        this.createDisposer();
        
        this.setState({
            fieldListId: this.props.match.params.id,
        }, () => {
            if ( this.state.fieldListId !== 'new' ) {
                this.AdminStore.getFieldLists(this.state.fieldListId);
            }
        });
    }

    public componentWillUnmount() {
        this.clearDisposer();
    }

    public createDisposer() {
        this.listDisposer = intercept(this.AdminStore, 'fieldList', (change: any) => {
            this.setState({
                fieldList: change.newValue
            });

            return change;
        });
    }

    public clearDisposer() {
        this.listDisposer();
    }

    public addNewOption() {
        const list: IOptionFieldList = this.state.fieldList;
        const newOption: IOptionFieldListItem = new IOptionFieldListItem();

        list.optionalFieldListItems.push(newOption);

        this.setState({
            fieldList: list,
            isDirty: true,
        });
    }

    public handleChange = (index: any) => (event: any) => {
        const list: IOptionFieldList = this.state.fieldList;
        const value: any = event.target.value;
        
        list.optionalFieldListItems[index].fieldItemName = value;

        this.setState({
            fieldList: list,
            isDirty: true,
        });
    }

    public handleSaveList() {
        this.AdminStore.saveFieldList(this.state.fieldList)
            .then(
                (data: any) => {
                    this.setState({
                        redirect: true
                    });

                    this.MessageStore.addMessage(
                        'Changes have been saved',
                        'success'
                    );
                },
                (error: any) => {
                    this.MessageStore.addMessage(
                        error.toString(),
                        'danger'
                    );
                }
            );
    }

    public removeFieldList() {
        this.AdminStore.deleteFieldList(this.state.fieldList)
            .then(
                (data: any) => {
                    this.setState({
                        redirect: true
                    });

                    this.MessageStore.addMessage(
                        'Option Field List Successfully Deleted',
                        'success'
                    );
                }
            );
    }

    public deleteItem = (index: number) => (event: any) => {
        const fieldList = this.state.fieldList;
        const areYouSure = confirm(`Are you sure you want to delete ${fieldList.optionalFieldListItems[index].fieldItemName}?`);
        if (areYouSure) {
            fieldList.optionalFieldListItems.splice(index, 1);
            this.setState({
                fieldList,
                isDirty: true
            });
        }
    }

    public render() {
        return(
            this.state.redirect ? (
                <Redirect to="/admin/fieldlists" />
            ) : (
                <div>
                    <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                    <Row className="header">
                        <Col md="12">
                            {this.state.fieldListId === 'new' ? (
                                <h2 className="float-left">Add New Field List</h2>
                            ) : (
                                <h2 className="float-left">Options for {this.state.fieldList.fieldListName}</h2>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                        {this.state.fieldList.optionalFieldListItems.map((item: IOptionFieldListItem, index: number) => 
                            <Row key={index}>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Name</Label>
                                        <EInput
                                            type="text"
                                            required={true}
                                            onChange={this.handleChange(index)}
                                            value={item.fieldItemName}
                                        />
                                    </FormGroup>
                                </Col>
                                {
                                    this.UserStore.hasPermission(`Permissions.Admin.OptionalFieldLists.${this.state.fieldList.routeName}.Update`) &&
                                    <Col md="6">
                                        <FormGroup>
                                            <Label />
                                            <div onClick={this.deleteItem(index)}>
                                                <FontAwesomeIcon
                                                    icon={faTrashAlt}
                                                    color={this.TenantStore.iconColor}
                                                    size={"2x"}
                                                    transform="shrink-3"
                                                    />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                }
                            </Row>
                        )}
                        {
                            this.UserStore.hasPermission(`Permissions.Admin.OptionalFieldLists.${this.state.fieldList.routeName}.Update`) &&
                            <Row>
                                <Col md="6">
                                    <Button color="primary" onClick={this.addNewOption}>Add New Option</Button>
                                </Col>
                            </Row>
                        }
                        </Col>
                    </Row>
                    {
                        this.UserStore.hasPermission(`Permissions.Admin.OptionalFieldLists.${this.state.fieldList.routeName}.Update`) &&
                        <ButtonRow>
                            <EButton color="primary" onClick={this.handleSaveList}>Save Options</EButton>
                        </ButtonRow>
                    }
                </div>
            )
        );
    }

}

export default DynamicFieldListDetails;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/DynamicFieldLists/DynamicFieldListDetails.tsx